// implement two functions in actual root-component:
// beforeWindowUnload(e) {
//   if (this.confirmStayInDirtyForm()) {
//     // Cancel the event
//     e.preventDefault();
//     // Chrome requires returnValue to be set
//     e.returnValue = '';
//   }
// }
//
// beforeRouteLeave(to, from, next) {
//   // If the form is dirty and the user did not confirm leave,
//   // prevent losing unsaved changes by canceling navigation
//   if (this.confirmStayInDirtyForm()) {
//     next(false);
//   } else {
//     // Navigate to next view
//     next();
//   }
// }

export default {
  data: function () {
    return {
      formIsDirty: false,
      unsavedPrompt: false,
      // persist of the `next` function from `beforeRouteLeave`
      unsavePromptNextPersist: null,
    };
  },
  created() {
    window.addEventListener('beforeunload', this.beforeWindowUnload);
  },
  beforeDestroy() {
    window.removeEventListener('beforeunload', this.beforeWindowUnload);
  },
  beforeRouteLeave(to, from, next) {
    this.beforeRouteLeave(to, from, next);
  },
};
